import { useEffect, useMemo, useState } from "react";
import '../styles/Form.css'
import { useAuth } from "./AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import { useDarkMode } from '../utils/DarkModeProvider';
import darkModeStyles from '../styles/TableDarkMode'
import lightModeStyles from '../styles/TableLightMode'
import { useGlobal } from '../utils/GlobalContext';
import Swal from 'sweetalert2'
import { ScaleLoader } from 'react-spinners';
import ListadoED from "../elementos/ListadoED";
import ListadoDocentesAEvaluar from "../elementos/ListadoDocentesAEvaluar";
import Formulario from "./Formulario";


export default function Home() {

    const navigate = useNavigate();

    const location = useLocation();
    const usuario = location.state?.usuario;

    const { user, logout, token } = useAuth();
    const usuarioActual = usuario || user;
    const { setGlobalState, globalState } = useGlobal()

    const { darkMode, toggleDarkMode } = useDarkMode();
    const dynamicStyles = darkMode ? darkModeStyles : lightModeStyles

    const { login, error, setError } = useAuth();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(true)
    const [evaluaciones, setEvaluaciones] = useState([])
    const [textosIngreso, setTextosIngreso] = useState([])
    const [loadingTextosIngreso, setLoadingTextosIngreso] = useState(false)
    const esAdmin = usuarioActual?.rol === 'Admin'
    const esDocente = usuarioActual?.rol === 'Docente'
    const esOperador = usuarioActual?.rol === 'Operador'
    const nombreUsuarioVisible = String(usuarioActual?.nombre || '').trim()


    const salir = () => {
        Swal.fire({
            title: "¿Seguro deseas salir?",
            icon: "question",
            showCancelButton: true,
            background: darkMode ? "#1e1e1e" : "#fff",
            color: darkMode ? "#fff" : "#545454",
            confirmButtonColor: darkMode ? "#66BB6A" : "#4CAF50",
            cancelButtonColor: darkMode ? "#e57373" : "#d9534f",
            confirmButtonText: "Confirmar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                logout()
            }
        })
    }

    useEffect(() => {
        if (!token || !usuarioActual) return

        fetch(`${process.env.REACT_APP_API_URL}/listado-periodos`, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        })
            .then((response) => {
                if (!response.ok) throw new Error('Error en la solicitud')
                return response.json()
            })
            .then((res) => {
                if (!Array.isArray(res)) {
                    setEvaluaciones([])
                    setError('Respuesta inválida al obtener periodos')
                    return
                }

                setEvaluaciones(res)

                if (res.length === 0) {
                    setError('No hay periodos disponibles para mostrar')
                }
            })
            .catch((error) => {
                console.log(error)
                setError(error.message)
            })
            .finally(() => {
                setLoading(false)
            })

    }, [token, navigate, usuarioActual, setError])

    useEffect(() => {
        if (!token || !esDocente) {
            setTextosIngreso([])
            return
        }

        setLoadingTextosIngreso(true)
        fetch(`${process.env.REACT_APP_API_URL}/textos-ingreso/`, {
            method: 'GET',
            headers: {
                accept: 'application/json',
                Authorization: `Bearer ${token}`
            }
        })
            .then((response) => {
                if (!response.ok) throw new Error('Error al obtener textos de ingreso')
                return response.json()
            })
            .then((res) => {
                if (!Array.isArray(res)) {
                    setTextosIngreso([])
                    return
                }
                setTextosIngreso(res)
            })
            .catch((errorTextos) => {
                console.log(errorTextos)
                setTextosIngreso([])
            })
            .finally(() => setLoadingTextosIngreso(false))
    }, [token, esDocente])

    const textosIngresoOrdenados = useMemo(() => {
        return [...textosIngreso].sort((a, b) => Number(a?.orden ?? 0) - Number(b?.orden ?? 0))
    }, [textosIngreso])

    const renderTextoConResaltado = (linea, keyPrefix) => {
        const partes = String(linea || '').split(/(\b\d{1,2}\/\d{1,2}\/\d{4}\b|[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})/g)

        return partes.map((parte, index) => {
            const key = `${keyPrefix}-${index}`
            if (!parte) return null

            const esFecha = /^\d{1,2}\/\d{1,2}\/\d{4}$/.test(parte)
            if (esFecha) {
                return (
                    <strong key={key} style={styles.fechaTexto}>
                        {parte}
                    </strong>
                )
            }

            const esCorreo = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(parte)
            if (esCorreo) {
                return (
                    <span key={key} style={styles.correoTexto}>
                        {parte}
                    </span>
                )
            }

            return <span key={key}>{parte}</span>
        })
    }

    return (
        <div className={darkMode ? "div-container-dark-mode" : "div-container-light-mode"} data-bs-theme={darkMode ? "dark" : "light"}>

            <img src={darkMode ? require('../assets/images/logo_unq_negativo_blanco.png') : require('../assets/images/logo_unq_negativo_negro_rojo.png')} className="unqImage" />
            <div className="toggle-container">
                <label className="toggle-switch">
                    <input type="checkbox" checked={darkMode} onChange={toggleDarkMode} />
                    <span className="slider"></span>
                    <span className="toggle-icons">
                        {darkMode ? '🌙' : '☀️'}
                    </span>
                </label>
            </div>

            <div className="container mt-5 mb-4">
                <div className="card shadow-lg p-4">
                    <h1 className="text-center mb-4" style={{ fontSize: '1.7rem' }}>Evaluación de Desempeño Docente</h1>
                    {nombreUsuarioVisible && (
                        <div style={styles.usuarioActualWrap}>
                            <span style={{ ...styles.usuarioActualBadge, ...(darkMode ? styles.usuarioActualBadgeDark : styles.usuarioActualBadgeLight) }}>
                                {nombreUsuarioVisible}
                            </span>
                        </div>
                    )}
                    {loading ?
                        <div style={{ alignSelf: 'center' }}>
                            <ScaleLoader color='#972034' />
                        </div>
                        :
                        <>
                            {(esAdmin || esOperador) ?
                                <ListadoDocentesAEvaluar usuario={usuarioActual} />
                                : esDocente ?
                                    <>
                                        <h5
                                            style={{
                                                ...styles.welcomeText,
                                                ...(darkMode ? styles.welcomeTextDark : styles.welcomeTextLight)
                                            }}
                                        >
                                            Le damos la bienvenida a la Evaluación de Desempeño Docente.
                                        </h5>
                                        <ListadoED usuario={usuarioActual} evaluaciones={evaluaciones} textosIngreso={textosIngresoOrdenados} />
                                        <div style={{ ...styles.ingresoTableCard, ...(darkMode ? styles.ingresoTableCardDark : styles.ingresoTableCardLight) }}>
                                            <div style={styles.ingresoTableHeader}>Información importante para el ingreso</div>
                                            {loadingTextosIngreso ? (
                                                <div style={styles.ingresoLoaderWrap}>
                                                    <ScaleLoader color={darkMode ? '#e5e7eb' : '#972034'} height={16} width={3} margin={2} />
                                                </div>
                                            ) : textosIngresoOrdenados.length > 0 ? (
                                                <div style={styles.ingresoTableWrapper}>
                                                    <table style={styles.ingresoTable}>
                                                        <tbody>
                                                            {textosIngresoOrdenados.map((item) => (
                                                                <tr key={item.id} style={{ ...(darkMode ? styles.ingresoRowDark : styles.ingresoRowLight) }}>
                                                                    <td style={{ ...styles.ingresoTextCell, ...(darkMode ? styles.ingresoTextCellDark : styles.ingresoTextCellLight) }}>
                                                                        {String(item?.texto || '')
                                                                            .split(/\r?\n/)
                                                                            .map((linea, index) => (
                                                                                <div key={`${item.id}-linea-${index}`}>
                                                                                    {renderTextoConResaltado(linea, `${item.id}-linea-${index}`)}
                                                                                </div>
                                                                            ))}
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ) : (
                                                <div style={{ ...styles.ingresoEmpty, ...(darkMode ? styles.ingresoTextCellDark : styles.ingresoTextCellLight) }}>
                                                    No hay textos de ingreso disponibles.
                                                </div>
                                            )}
                                        </div>
                                    </>
                                    :
                                    <div style={styles.roleError}>Usuario sin rol</div>
                            }
                            <button
                                style={{ ...dynamicStyles.logoutButton, marginTop: 30 }}
                                onMouseOver={(e) => e.target.style.backgroundColor = dynamicStyles.logoutButtonHover.backgroundColor}
                                onMouseOut={(e) => e.target.style.backgroundColor = dynamicStyles.logoutButton.backgroundColor}
                                onClick={salir}
                            >
                                Salir
                            </button>
                        </>
                    }
                </div>
            </div>


        </div>
    );
}

const styles = {
    imageContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: 25,
    },
    inputGroup: {
        marginBottom: '15px',
        textAlign: 'left'
    },
    // input: {
    //     width: '100%',
    //     padding: '10px',
    //     border: '1px solid #ccc',
    //     borderRadius: '5px',
    //     outline: 'none',
    //     fontSize: '14px'
    // },
    button: {
        width: '100%',
        backgroundColor: '#972034',
        color: '#fff',
        padding: '10px',
        border: 'none',
        borderRadius: '5px',
        fontSize: '16px',
        fontWeight: 'bold',
        cursor: 'pointer',
        transition: 'background 0.3s',
    },
    buttonHover: {
        backgroundColor: '#A23C41'
    },
    link: {
        color: '#0F6EFD',
        fontWeight: 'bold',
        textDecoration: 'none'
    },
    welcomeText: {
        margin: '0 0 16px 0',
        padding: '10px 12px',
        borderRadius: '10px',
        fontSize: '1.02rem',
        fontWeight: 600,
        lineHeight: 1.35,
        borderLeft: '4px solid #972034'
    },
    welcomeTextLight: {
        backgroundColor: '#f3f4f6',
        color: '#4b5563'
    },
    welcomeTextDark: {
        backgroundColor: '#2a2f35',
        color: '#e5e7eb'
    },
    usuarioActualWrap: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: '-10px',
        marginBottom: '12px'
    },
    usuarioActualBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '5px 10px',
        borderRadius: '999px',
        fontSize: '0.92rem',
        fontWeight: 700,
        letterSpacing: '0.01em',
        border: '1px solid'
    },
    usuarioActualBadgeLight: {
        backgroundColor: '#f8fafc',
        borderColor: '#dbe3ea',
        color: '#334155'
    },
    usuarioActualBadgeDark: {
        backgroundColor: '#1f2937',
        borderColor: '#374151',
        color: '#e5e7eb'
    },
    ingresoTableCard: {
        marginTop: '4px',
        borderRadius: '12px',
        overflow: 'hidden',
        border: '1px solid',
        boxShadow: '0 8px 20px rgba(0, 0, 0, 0.08)'
    },
    ingresoTableCardLight: {
        backgroundColor: '#ffffff',
        borderColor: '#e5e7eb'
    },
    ingresoTableCardDark: {
        backgroundColor: '#1f242a',
        borderColor: '#374151'
    },
    ingresoTableHeader: {
        padding: '10px 12px',
        fontSize: '0.95rem',
        fontWeight: 700,
        letterSpacing: '0.01em',
        background: 'linear-gradient(90deg, rgba(151,32,52,0.95) 0%, rgba(151,32,52,0.78) 100%)',
        color: '#fff'
    },
    ingresoLoaderWrap: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 84,
        padding: '8px 0'
    },
    ingresoTableWrapper: {
        overflowX: 'auto'
    },
    ingresoTable: {
        width: '100%',
        borderCollapse: 'collapse'
    },
    ingresoRowLight: {
        borderBottom: '1px solid #eef2f7'
    },
    ingresoRowDark: {
        borderBottom: '1px solid #2f3742'
    },
    ingresoTextCell: {
        padding: '10px 12px',
        fontSize: '0.93rem',
        lineHeight: 1.45,
        whiteSpace: 'normal'
    },
    ingresoTextCellLight: {
        color: '#334155'
    },
    ingresoTextCellDark: {
        color: '#e5e7eb'
    },
    fechaTexto: {
        fontWeight: 800
    },
    correoTexto: {
        color: '#38bdf8',
        fontWeight: 600
    },
    ingresoEmpty: {
        padding: '12px',
        fontStyle: 'italic'
    },
    roleError: {
        textAlign: 'center',
        color: '#972034',
        fontSize: '20px',
        fontWeight: '700',
        padding: '24px 12px'
    }
};
